module.exports = __webpack_public_path__ + "static/media/video-yt.b3d5e982.jpg";